import Thingy from "./es5/Thingy.js";
export default Thingy;